// src/services/userRoleEventService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getUserRoleEvents = async () => {
  return await axios.get(`${API_URL}/user-role-events`);
};

const getUserRoleEvent = async (id) => {
  return await axios.get(`${API_URL}/user-role-events/${id}`);
};

const createUserRoleEvent = async (userRoleEventData) => {
  return await axios.post(`${API_URL}/user-role-events`, userRoleEventData);
};

const updateUserRoleEvent = async (id, userRoleEventData) => {
  return await axios.put(`${API_URL}/user-role-events/${id}`, userRoleEventData);
};

const deleteUserRoleEvent = async (id) => {
  return await axios.delete(`${API_URL}/user-role-events/${id}`);
};

export default {
  getUserRoleEvents,
  getUserRoleEvent,
  createUserRoleEvent,
  updateUserRoleEvent,
  deleteUserRoleEvent,
};
